<template>
  <BCIconBanner fluid background-color="#DFEEC7" icon-color="#5BC4A6">
    <div class="container">
      <div class="row">
        <div
          class="col-md-10 offset-md-1 details-download-info overflow-hidden text-start"
        >
          <h3 class="details-download-info__heading mb-24 mb-lg-8">
            {{ $label(`${downloadInfoLabelPath}.heading`) }}
          </h3>
          <ul>
            <li class="mb-16 mb-lg-8">
              {{ $label(`${downloadInfoLabelPath}.item1`) }}
            </li>
            <li v-if="!isExtraCategoryBook" class="mb-16 mb-lg-8">
              {{ $label(`${downloadInfoLabelPath}.item2`) }}
            </li>
            <li>
              {{ $label(`${downloadInfoLabelPath}.item3`) }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </BCIconBanner>
</template>

<script>
import BCIconBanner from '~/components/banners/BCIconBanner'

export default {
  components: {
    BCIconBanner,
  },
  props: {
    isExtraCategoryBook: {
      type: Boolean,
      default: false,
    },
    loggedInUser: {
      type: [Object, Boolean],
      default: false,
    },
  },
  computed: {
    downloadInfoLabelPath() {
      return this.loggedInUser
        ? 'page.downloadInfo'
        : 'page.downloadInfoLoggedOut'
    },
  },
}
</script>

<style lang="scss" scoped>
.bc-icon-banner {
  margin-bottom: -8px;
}

.details-download-info {
  ul {
    margin-bottom: 0;
    padding-left: 26px;
  }
}

@include media-breakpoint-up(lg) {
  .bc-icon-banner {
    margin-bottom: 64px;
  }
}
</style>
